import clsx from 'clsx';

import Button from '../button/Button';
import {
  getFieldSelectedCount,
  isFieldDisabled
} from './multiFieldFilterHelpers';
import {
  FieldOptionObjV2,
  SelectAllModes,
  SelectedFilterValues
} from './types';

interface FilterSidebarProps {
  fieldOptions: FieldOptionObjV2;
  activeField: string;
  selected: SelectedFilterValues;
  selectAllModes: SelectAllModes;
  excludedItems: SelectedFilterValues;
  type: 'multi' | 'single';
  onSelectField: (field: string) => void;
}

const FilterSidebar = ({
  fieldOptions,
  activeField,
  selected,
  selectAllModes,
  excludedItems,
  type,
  onSelectField
}: FilterSidebarProps) => (
  <div className="custom-scroll flex w-55 shrink-0 flex-col gap-1.5 overflow-y-auto overscroll-contain py-2 pl-4 pr-2">
    {Object.values(fieldOptions).map((field) => {
      const disabled = isFieldDisabled(field, selected);
      const active = activeField === field.field && !disabled;
      const count = getFieldSelectedCount(
        field,
        selected,
        selectAllModes,
        excludedItems
      );

      return (
        <Button
          key={field.id}
          variant="tertiary"
          disabled={disabled}
          tooltipText={disabled ? field.disabledTooltip : undefined}
          handleClick={() => onSelectField(field.field)}
          className={clsx(
            '!flex !w-full !items-center !justify-between',
            '!rounded-md !border-none !px-2 !py-3.5',
            '!text-sm !leading-none !tracking-normal',
            disabled ? '!cursor-not-allowed !opacity-50' : '!cursor-pointer',
            active
              ? '!bg-cofeeGreyBlue2 !font-medium !text-primary'
              : '!font-normal !text-cofeeNeutral10'
          )}
        >
          <span>{field.label}</span>
          {type === 'multi' && count > 0 && (
            <div className="flex size-6 items-center justify-center rounded-full bg-primary text-sm text-white">
              {count}
            </div>
          )}
        </Button>
      );
    })}
  </div>
);

export default FilterSidebar;
